import request from "@/utils/request";

export default function agentGetMonthlyInfoById(id) {
  return request({
    url: `/device/monthly/agentGetMonthlyInfoById/${id}`,
  });
}
